var map = {
	"./Screenshot_1.jpg": 3976,
	"./chamfering.jpg": 12991,
	"./felc.jpg": 54040,
	"./front-model.png": 72238,
	"./glassCases/w1/front.png": 23919,
	"./glassCases/w1/izometric.png": 40157,
	"./glassCases/w1/model.jpg": 30569,
	"./glassCases/w1/przekroj.png": 64505,
	"./glassCases/w4/front.png": 70309,
	"./glassCases/w4/izometric.png": 73594,
	"./glassCases/w4/model.jpg": 59062,
	"./glassCases/w4/przekroj.png": 93084,
	"./glassCases/w6/front.png": 76866,
	"./glassCases/w6/izometric.png": 19605,
	"./glassCases/w6/model.jpg": 72891,
	"./glassCases/w6/przekroj.png": 30992,
	"./glassCases/w7/front.png": 38226,
	"./glassCases/w7/izometric.png": 42103,
	"./glassCases/w7/model.jpg": 1720,
	"./glassCases/w7/przekroj.png": 57171,
	"./handles/p45/izometric.png": 75065,
	"./handles/p45/model.jpg": 16207,
	"./handles/p45/przekroj.png": 56292,
	"./handles/uc/front.png": 68142,
	"./handles/uc/izometric.png": 90027,
	"./handles/uc/model.jpg": 6161,
	"./handles/uc/przekroj.png": 2584,
	"./handles/uk/front.png": 98394,
	"./handles/uk/izometric.png": 19234,
	"./handles/uk/model.jpg": 49479,
	"./handles/uk/przekroj.png": 71879,
	"./handles/uk/przekroj2.png": 74181,
	"./handles/uk45/izometric.png": 51379,
	"./handles/uk45/model.jpg": 82105,
	"./handles/uk45/przekroj.png": 46133,
	"./handles/up/izometric.png": 2294,
	"./handles/up/model.jpg": 64046,
	"./handles/up/przekroj.png": 9668,
	"./handles/up45/front.png": 25076,
	"./handles/up45/izometric.png": 46020,
	"./handles/up45/model.jpg": 37174,
	"./handles/up45/przekroj.png": 18768,
	"./handles/uz/model.jpg": 37362,
	"./landing_background.jpg": 82872,
	"./landing_background2.jpg": 47907,
	"./logo.png": 74427,
	"./manual/catalog1.png": 29517,
	"./manual/catalog2.png": 41432,
	"./manual/catalog3.png": 12458,
	"./manual/form1.png": 83980,
	"./manual/form2.png": 22944,
	"./manual/form3.png": 22562,
	"./manual/form4.png": 74968,
	"./manual/form5.png": 90776,
	"./manual/new.png": 91571,
	"./millings/E1/front.png": 92070,
	"./millings/E1/izometric.png": 42642,
	"./millings/E1/model.jpg": 55004,
	"./millings/E1/przekroj.png": 96362,
	"./millings/E2/front.png": 4582,
	"./millings/E2/izometric.png": 20736,
	"./millings/E2/model.jpg": 34250,
	"./millings/E2/przekroj.png": 69270,
	"./millings/E3/front.png": 35555,
	"./millings/E3/izometric.png": 37708,
	"./millings/E3/model.jpg": 72909,
	"./millings/E3/przekroj.png": 92901,
	"./millings/J1/Część8.par": 14862,
	"./millings/J1/front.png": 43726,
	"./millings/J1/izometric.png": 18705,
	"./millings/J1/model.jpg": 69206,
	"./millings/J1/przekroj.png": 56466,
	"./millings/J10/front.png": 63023,
	"./millings/J10/izometric.png": 55075,
	"./millings/J10/model.jpg": 75811,
	"./millings/J10/przekroj.png": 90894,
	"./millings/J12/front.png": 58990,
	"./millings/J12/izometric.png": 54891,
	"./millings/J12/model.jpg": 87687,
	"./millings/J12/przekroj.png": 36319,
	"./millings/J13/front.png": 35484,
	"./millings/J13/izometric.png": 41287,
	"./millings/J13/model.jpg": 88057,
	"./millings/J13/przekroj.png": 84866,
	"./millings/J2/front.png": 41542,
	"./millings/J2/izometric.png": 57639,
	"./millings/J2/model.jpg": 76696,
	"./millings/J2/przekroj.png": 62753,
	"./millings/J3/front.png": 29372,
	"./millings/J3/izometric.png": 78464,
	"./millings/J3/model.jpg": 74199,
	"./millings/J3/przekroj.png": 31881,
	"./millings/J4/front.png": 83172,
	"./millings/J4/izometric.png": 41324,
	"./millings/J4/model.jpg": 58643,
	"./millings/J4/model.par": 89928,
	"./millings/J4/przekroj.png": 22626,
	"./millings/J4/rysunek.dft": 91906,
	"./millings/J5/Część12.par": 70865,
	"./millings/J5/front.png": 57505,
	"./millings/J5/izometric.png": 45083,
	"./millings/J5/model.jpg": 24968,
	"./millings/J5/przekroj.png": 52846,
	"./millings/J6/front.png": 60131,
	"./millings/J6/izometric.png": 8642,
	"./millings/J6/model.jpg": 93270,
	"./millings/J6/model.par": 42530,
	"./millings/J6/przekroj.png": 95246,
	"./millings/J6/rys.dft": 11329,
	"./millings/J7/Część4.par": 63297,
	"./millings/J7/front.png": 17973,
	"./millings/J7/izometric.png": 22121,
	"./millings/J7/model.jpg": 44358,
	"./millings/J7/przekroj.png": 15704,
	"./millings/J8/front.png": 72465,
	"./millings/J8/izometric.png": 74384,
	"./millings/J8/model.jpg": 9168,
	"./millings/J8/przekroj.png": 87335,
	"./millings/J9/front.png": 66951,
	"./millings/J9/izometric.png": 92705,
	"./millings/J9/model.jpg": 53909,
	"./millings/J9/przekroj.png": 73756,
	"./millings/ryflowany/Część8.par": 12924,
	"./millings/ryflowany/front.png": 39962,
	"./millings/ryflowany/izometric.png": 56704,
	"./millings/ryflowany/model.jpg": 96149,
	"./millings/ryflowany/przekroj.png": 56085,
	"./mordant/brown/braz_22_40.jpg": 72682,
	"./mordant/brown/braz_22_42.jpg": 57796,
	"./mordant/brown/braz_22_45.jpg": 52816,
	"./mordant/brown/braz_22_46.jpg": 30080,
	"./mordant/brown/braz_22_481.jpg": 4761,
	"./mordant/brown/braz_22_50.jpg": 48637,
	"./mordant/brown/braz_22_51.jpg": 15870,
	"./mordant/brown/braz_22_55.jpg": 18447,
	"./mordant/brown/braz_22_56.jpg": 22942,
	"./mordant/brown/braz_bpa_d262_16.jpg": 77128,
	"./mordant/brown/brunat_22_01.jpg": 1527,
	"./mordant/brown/brunat_22_041.jpg": 49763,
	"./mordant/brown/brunat_22_05.jpg": 29595,
	"./mordant/brown/brunat_22_07.jpg": 2685,
	"./mordant/brown/brunat_22_10.jpg": 4500,
	"./mordant/brown/brunat_22_112.jpg": 50883,
	"./mordant/brown/brunat_22_15.jpg": 25713,
	"./mordant/brown/brunat_22_23.jpg": 59394,
	"./mordant/brown/brunat_22_25.jpg": 10744,
	"./mordant/brown/brunat_22_27.jpg": 40270,
	"./mordant/brown/brunat_bpa_d185_16.jpg": 15807,
	"./mordant/brown/brunat_bpa_d260_16.jpg": 69365,
	"./mordant/brown/czern_29_10.jpg": 31124,
	"./mordant/brown/czern_bpa_d109_16.jpg": 27729,
	"./mordant/brown/czern_bpa_d118_16.jpg": 35438,
	"./mordant/brown/czern_bpa_d263_16.jpg": 3126,
	"./mordant/brown/czern_bpa_df349_16.jpg": 92860,
	"./mordant/brown/grafit_bpa_d10.jpg": 97265,
	"./mordant/brown/murano_bpa_d03.jpg": 42600,
	"./mordant/brown/orzech_22_60.jpg": 39869,
	"./mordant/brown/orzech_22_61.jpg": 63997,
	"./mordant/brown/orzech_22_62.jpg": 34837,
	"./mordant/brown/orzech_22_63.jpg": 34282,
	"./mordant/brown/orzech_22_65.jpg": 80495,
	"./mordant/brown/orzech_22_66.jpg": 98695,
	"./mordant/brown/orzech_22_68.jpg": 35084,
	"./mordant/brown/orzech_22_74.jpg": 43258,
	"./mordant/brown/tosca_bpa_d04.jpg": 25494,
	"./mordant/brown/traviata_bpa_d07.jpg": 67549,
	"./mordant/brown/trufla_bpa_d01.jpg": 40994,
	"./mordant/brown/venge_bpa_d09.jpg": 49191,
	"./mordant/brown/wenge_bpa_d142_16.jpg": 36737,
	"./mordant/green/granat_28_60_01.jpg": 81827,
	"./mordant/green/niebieski_bpa_d211_16.jpg": 59605,
	"./mordant/green/oliw_27_50.jpg": 94718,
	"./mordant/green/zielen_27_26.jpg": 26649,
	"./mordant/white/bez_bn_125_09.jpg": 53492,
	"./mordant/white/bez_bpa_d122_16.jpg": 81557,
	"./mordant/white/bez_bpa_d208_16.jpg": 63985,
	"./mordant/white/bez_bpa_d213_16.jpg": 13549,
	"./mordant/white/bez_bpa_d244_13.jpg": 19626,
	"./mordant/white/bez_bpa_d352_14.jpg": 17992,
	"./mordant/white/bez_bpa_d92_13.jpg": 18815,
	"./mordant/white/bez_bpa_df342_16.jpg": 69265,
	"./mordant/white/bez_bpa_df343_16.jpg": 58025,
	"./mordant/white/bez_bpa_df344_16.jpg": 50398,
	"./mordant/white/bez_bpa_df346_16.jpg": 51780,
	"./mordant/white/biel_20_01.jpg": 58742,
	"./mordant/white/biel_bpa_d154_16.jpg": 79829,
	"./mordant/white/giovanni_bpa_d06.jpg": 98142,
	"./mordant/white/latte_bpa_d08.jpg": 20701,
	"./mordant/white/nabucco_bpa_d05.jpg": 95909,
	"./mordant/white/popiel_20_07.jpg": 29646,
	"./mordant/white/popiel_bn_022.jpg": 71372,
	"./mordant/white/popiel_bpa_d10_16.jpg": 60269,
	"./mordant/white/popiel_bpa_d125_16.jpg": 6998,
	"./mordant/white/popiel_bpa_d126_16.jpg": 27320,
	"./mordant/white/popiel_bpa_d130_16.jpg": 89595,
	"./mordant/white/popiel_bpa_d153_16.jpg": 65563,
	"./mordant/white/popiel_bpa_d165_16.jpg": 11368,
	"./mordant/white/popiel_bpa_d292_16.jpg": 18643,
	"./mordant/white/popiel_bpa_d31_16.jpg": 38933,
	"./mordant/white/popiel_bpa_d407_13.jpg": 34062,
	"./mordant/white/popiel_bpa_d47_16.jpg": 62597,
	"./mordant/white/popiel_bpa_d49_16.jpg": 98591,
	"./mordant/white/popiel_bpa_d63_16.jpg": 72212,
	"./mordant/white/popiel_bpa_d82_16.jpg": 84392,
	"./mordant/white/popiel_bpa_d89_16.jpg": 65137,
	"./mordant/white/popiel_bpa_df165_16w.jpg": 42835,
	"./mordant/white/popiel_bpa_df184_13.jpg": 75709,
	"./mordant/white/popiel_bpa_df185_13.jpg": 31173,
	"./mordant/white/popiel_bpa_df341_16.jpg": 71209,
	"./mordant/white/popiel_bpa_df347_16.jpg": 98617,
	"./mordant/white/popiel_bpa_df348_16.jpg": 93636,
	"./mordant/white/sonoma_bpa_d02.jpg": 27195,
	"./mordant/yellow/heban_25_50.jpg": 59763,
	"./mordant/yellow/mahon_25_25.jpg": 8929,
	"./mordant/yellow/oranz_23_01.jpg": 44859,
	"./mordant/yellow/oranz_23_05.jpg": 77806,
	"./mordant/yellow/oranz_23_24.jpg": 35344,
	"./mordant/yellow/oranz_23_25.jpg": 98980,
	"./mordant/yellow/oranz_23_29.jpg": 20400,
	"./mordant/yellow/palisander_26_32.jpg": 69288,
	"./mordant/yellow/teak_23_32.jpg": 84841,
	"./mordant/yellow/teak_23_351.jpg": 76246,
	"./mordant/yellow/teak_23_46.jpg": 42477,
	"./mordant/yellow/teak_23_48.jpg": 12185,
	"./mordant/yellow/teak_23_49.jpg": 82179,
	"./mordant/yellow/teak_23_50.jpg": 74668,
	"./mordant/yellow/teak_23_64.jpg": 49425,
	"./mordant/yellow/teak_bpa_d256_16.jpg": 26094,
	"./mordant/yellow/teak_bpa_d279_16.jpg": 12963,
	"./mordant/yellow/zolcien_21_05.jpg": 50591,
	"./mordant/yellow/zolcien_21_19.jpg": 74203,
	"./mordant/yellow/zolcien_21_37.jpg": 73078,
	"./mordant/yellow/zolcien_21_57.jpg": 50587,
	"./mordant/yellow/zolcien_bpa_d105_16.jpg": 72739,
	"./mordant/yellow/zolcien_bpa_d140_16.jpg": 65873,
	"./nut.jpg": 8663,
	"./pdf-icon.png": 17570,
	"./veneers/alpi/01.anegre.jpg": 50093,
	"./veneers/alpi/02.ayous.jpg": 25678,
	"./veneers/alpi/03.brzoza.jpg": 83681,
	"./veneers/alpi/04.buk.jpg": 40496,
	"./veneers/alpi/05.czeresnia-amerykanska_fl.jpg": 65090,
	"./veneers/alpi/06.jpg": 29998,
	"./veneers/alpi/07.dab1.jpg": 79364,
	"./veneers/alpi/08.dab2.jpg": 59540,
	"./veneers/alpi/09.dab-bielony.jpg": 59231,
	"./veneers/alpi/10.dab_bryza.jpg": 72563,
	"./veneers/alpi/11.dab-dymiony.jpg": 81890,
	"./veneers/alpi/12.d_b-flader.jpg": 16647,
	"./veneers/alpi/13.d_b-grafit.jpg": 30702,
	"./veneers/alpi/14.d_b-kakao.jpg": 19411,
	"./veneers/alpi/15.dab-mleczny.jpg": 20863,
	"./veneers/alpi/16.dab-moro.jpg": 74120,
	"./veneers/alpi/17.d_b-prosty.jpg": 84808,
	"./veneers/alpi/18.dab_rustikal.jpg": 43950,
	"./veneers/alpi/19.dab-szary1.jpg": 65155,
	"./veneers/alpi/20.dab-szary2.jpg": 79644,
	"./veneers/alpi/21.dab-w_dzony.jpg": 18915,
	"./veneers/alpi/22.heban.jpg": 13555,
	"./veneers/alpi/23.heban-ammara.jpg": 54652,
	"./veneers/alpi/24.heban_brazylijski.jpg": 10027,
	"./veneers/alpi/25.heban-czarno-biay.jpg": 3606,
	"./veneers/alpi/26.heban-flader.jpg": 94684,
	"./veneers/alpi/27.heban_gabon.jpg": 72108,
	"./veneers/alpi/28.heban-makassar-flader_2E.jpg": 63113,
	"./veneers/alpi/29.heban-makassar-pasiak_2E.jpg": 9640,
	"./veneers/alpi/30.heban-yoruba.jpg": 89984,
	"./veneers/alpi/31.jesion.jpg": 61903,
	"./veneers/alpi/32.klon.jpg": 64366,
	"./veneers/alpi/33.klon_piaskowy.jpg": 924,
	"./veneers/alpi/34.klon_pawie_oczko.jpg": 12339,
	"./veneers/alpi/35.mahon.jpg": 96680,
	"./veneers/alpi/36.orzech.jpg": 6514,
	"./veneers/alpi/37.orzech-amerykanski.jpg": 88222,
	"./veneers/alpi/38.orzech-boliwijski.jpg": 83226,
	"./veneers/alpi/39.orzech-canaletto-flader.jpg": 77881,
	"./veneers/alpi/40.orzech-canaletto-pasiak.jpg": 44254,
	"./veneers/alpi/41.orzech_czarny.jpg": 95186,
	"./veneers/alpi/42.orzech_czeczot_ciemny.jpg": 39162,
	"./veneers/alpi/43.orzech_czeczot_jasny.jpg": 8619,
	"./veneers/alpi/44.orzech-w_oski.jpg": 15769,
	"./veneers/alpi/45.palisander.jpg": 14195,
	"./veneers/alpi/46.palisander-indyjski.jpg": 70422,
	"./veneers/alpi/47.palisander-madagaskar-EB.jpg": 43650,
	"./veneers/alpi/48.palisander-santos.jpg": 39892,
	"./veneers/alpi/49.sosna.jpg": 31931,
	"./veneers/alpi/50.teak.jpg": 84902,
	"./veneers/alpi/51.teak-burma.jpg": 97649,
	"./veneers/alpi/52.teak-rigatto.jpg": 1787,
	"./veneers/alpi/53.wenge.jpg": 37831,
	"./veneers/alpi/54.wenge1.jpg": 41005,
	"./veneers/alpi/55.wenge-drobnos_oiste.jpg": 33172,
	"./veneers/alpi/56.wenge-drobne-moro.jpg": 5410,
	"./veneers/alpi/57.wenge-flader.jpg": 56536,
	"./veneers/alpi/58.wenge-pasiak.jpg": 84556,
	"./veneers/alpi/59.wi_nia.jpg": 44917,
	"./veneers/alpi/60.zebrano.jpg": 55546,
	"./veneers/alpi/61.zebrano-bianco.jpg": 70891,
	"./veneers/californiaTrading/Bambus-carmel-natural-BNCW-.jpg": 21837,
	"./veneers/californiaTrading/Bambus-carmel-szeroki-BCSZ-.jpg": 23416,
	"./veneers/californiaTrading/Bambus-carmel-waski-BCW-45P.jpg": 1661,
	"./veneers/californiaTrading/Bambus-natural-szeroki-BNSZ.jpg": 72972,
	"./veneers/californiaTrading/Bambus-natural-waski-BNW-35.jpg": 2399,
	"./veneers/californiaTrading/Buk-BU-0102TW.jpg": 39198,
	"./veneers/californiaTrading/Czeczotka-california-CC-OKO-07.jpg": 98767,
	"./veneers/californiaTrading/Czeczotka-california-CC-OKO-08.jpg": 29225,
	"./veneers/californiaTrading/Czeresnia-CZ-0119F1.jpg": 84042,
	"./veneers/californiaTrading/Dab-DA-0003PP.jpg": 59925,
	"./veneers/californiaTrading/Dab-DA-0004PS.jpg": 72571,
	"./veneers/californiaTrading/Dab-DA-0006PS.jpg": 77340,
	"./veneers/californiaTrading/Dab-DA-0052F3.jpg": 49069,
	"./veneers/californiaTrading/Dab-DA-0101PS.jpg": 55862,
	"./veneers/californiaTrading/Dab-DA-0609PS.jpg": 52492,
	"./veneers/californiaTrading/Dab-bielony-DB-0001PS.jpg": 12112,
	"./veneers/californiaTrading/Dab-brazowo-srebrny-DBS-105.jpg": 17787,
	"./veneers/californiaTrading/Dab-czarno-srebrny-DCZ-1058.jpg": 84432,
	"./veneers/californiaTrading/Dab-pastelowy-DP-1903PS.jpg": 15495,
	"./veneers/californiaTrading/Dab-siwy-DS-0005PS.jpg": 72659,
	"./veneers/californiaTrading/Dab-szary-DSZ-0007F.jpg": 18322,
	"./veneers/californiaTrading/Drzewo-lodowe-bianco-DL-030.jpg": 32446,
	"./veneers/californiaTrading/Drzewo-lodowe-negro-DL-0301.jpg": 77537,
	"./veneers/californiaTrading/Drzewo-sandalowe-DS-0008PS.jpg": 5411,
	"./veneers/californiaTrading/Grusza-indyjska-GI-2307-3D.jpg": 85027,
	"./veneers/californiaTrading/Heban-HE-0004PP.jpg": 86237,
	"./veneers/californiaTrading/Heban-HE-0102PI.jpg": 96581,
	"./veneers/californiaTrading/Heban-HE-2102-3D.jpg": 50603,
	"./veneers/californiaTrading/Heban-HE-7001PS.jpg": 14223,
	"./veneers/californiaTrading/Heban-HE-7064PS.jpg": 19739,
	"./veneers/californiaTrading/Heban-HE-7069PS.jpg": 2637,
	"./veneers/californiaTrading/Kamelia-KA-0004PW.jpg": 56522,
	"./veneers/californiaTrading/Klon-KL-0234F3.jpg": 25693,
	"./veneers/californiaTrading/Mahon-MA-0151PA.jpg": 92813,
	"./veneers/californiaTrading/Mahon-MA-1101PA.jpg": 4944,
	"./veneers/californiaTrading/Orzech-OR-0017CT.jpg": 60912,
	"./veneers/californiaTrading/Orzech-OR-0518F1.jpg": 43096,
	"./veneers/californiaTrading/Orzech-OR-1001PS.jpg": 30658,
	"./veneers/californiaTrading/Palisander-PA-0002F1.jpg": 8024,
	"./veneers/californiaTrading/Palisander-PA-1102PS.jpg": 70673,
	"./veneers/californiaTrading/Palisander-PA-1103F.jpg": 84718,
	"./veneers/californiaTrading/Palisander-violet-PV-1104PS.jpg": 38204,
	"./veneers/californiaTrading/Rose-RO-0011PS.jpg": 97685,
	"./veneers/californiaTrading/Roza-hiszpanskaRH-0703-3D.jpg": 91045,
	"./veneers/californiaTrading/Sosna-SO-0201PW.jpg": 95502,
	"./veneers/californiaTrading/Tik-TI-0001PS.jpg": 86611,
	"./veneers/californiaTrading/Tik-TI-0002PS.jpg": 11167,
	"./veneers/californiaTrading/Tik-TI-0018PS.jpg": 43875,
	"./veneers/californiaTrading/Tik-TI-3001PW.jpg": 84986,
	"./veneers/californiaTrading/Tik-californijski-TC-0804-3.jpg": 19163,
	"./veneers/californiaTrading/WE-5001PW.jpg": 27875,
	"./veneers/californiaTrading/Wenge-WE-0002PI.jpg": 1927,
	"./veneers/californiaTrading/Wenge-WE-0003PP.jpg": 39281,
	"./veneers/californiaTrading/Wenge-WE-2010PI.jpg": 70366,
	"./veneers/californiaTrading/Wenge-WE-5006PW.jpg": 98599,
	"./veneers/californiaTrading/Wiaz-WI-0012PS.jpg": 8575,
	"./veneers/californiaTrading/Zebrano-ZE-0001PS.jpg": 27899,
	"./veneers/californiaTrading/Zebrano-ZE-0087PS.jpg": 73431,
	"./veneers/natural/acajou.jpg": 39814,
	"./veneers/natural/amazakue.jpg": 83306,
	"./veneers/natural/anegre.jpg": 38281,
	"./veneers/natural/badi.jpg": 95533,
	"./veneers/natural/bambus_ciemny.jpg": 12914,
	"./veneers/natural/bambus_jasny.jpg": 13980,
	"./veneers/natural/brzoza-skand.jpg": 20123,
	"./veneers/natural/bubinga.jpg": 67140,
	"./veneers/natural/buk.jpg": 40890,
	"./veneers/natural/ceiba.jpg": 35630,
	"./veneers/natural/cocobolo.jpg": 16181,
	"./veneers/natural/czeresnia-ameryk.jpg": 28763,
	"./veneers/natural/dab.jpg": 91558,
	"./veneers/natural/dab_czarny.jpg": 33717,
	"./veneers/natural/dab_czeczot.jpg": 28162,
	"./veneers/natural/drzewo_kasztanowe.jpg": 77833,
	"./veneers/natural/drzewo_rozane.jpg": 35476,
	"./veneers/natural/drzewo_tygrysie.jpg": 38744,
	"./veneers/natural/eldorado.jpg": 22505,
	"./veneers/natural/frake_czarne.jpg": 49811,
	"./veneers/natural/frejo.jpg": 71944,
	"./veneers/natural/grusza.jpg": 35284,
	"./veneers/natural/heban.jpg": 97581,
	"./veneers/natural/iroko.jpg": 85443,
	"./veneers/natural/jablon_indyjska.jpg": 88908,
	"./veneers/natural/jatoba.jpg": 88386,
	"./veneers/natural/jesion.jpg": 37202,
	"./veneers/natural/klon.jpg": 17661,
	"./veneers/natural/koto.jpg": 17233,
	"./veneers/natural/limba.jpg": 74151,
	"./veneers/natural/makore.jpg": 7471,
	"./veneers/natural/meranti.jpg": 7525,
	"./veneers/natural/merbau.jpg": 26891,
	"./veneers/natural/okume.jpg": 33360,
	"./veneers/natural/olcha.jpg": 12172,
	"./veneers/natural/oliwka.jpg": 90683,
	"./veneers/natural/orzech-ameryk.jpg": 28421,
	"./veneers/natural/orzech_boliwia.jpg": 87511,
	"./veneers/natural/orzech_czeczota.jpg": 10626,
	"./veneers/natural/orzech_wloski.jpg": 5850,
	"./veneers/natural/palisander-santos.jpg": 18201,
	"./veneers/natural/palisander_indyjski.jpg": 91270,
	"./veneers/natural/palisander_madagaskar.jpg": 46611,
	"./veneers/natural/palisander_rio.jpg": 90743,
	"./veneers/natural/rozowe_luski.jpg": 66856,
	"./veneers/natural/sapeli-flader.jpg": 34587,
	"./veneers/natural/sapeli-pasiak.jpg": 78482,
	"./veneers/natural/sosna.jpg": 39927,
	"./veneers/natural/teak.jpg": 72492,
	"./veneers/natural/tipo_cocobolo.jpg": 52754,
	"./veneers/natural/tulipanowiec.jpg": 67301,
	"./veneers/natural/wenge.jpg": 6048,
	"./veneers/natural/zebrano.jpg": 84215,
	"./veneers/natural/ziricote.jpg": 55171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;